import { render, staticRenderFns } from "./behavioral-skill.component.vue?vue&type=template&id=6178ebed&scoped=true&"
import script from "./behavioral-skill.component.vue?vue&type=script&lang=ts&"
export * from "./behavioral-skill.component.vue?vue&type=script&lang=ts&"
import style0 from "./behavioral-skill.component.vue?vue&type=style&index=0&id=6178ebed&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6178ebed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
